module.exports = __webpack_public_path__ + "img/share.a6b562b8.svg";